var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOnboardingSecond(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 410,
    height: 406,
    viewBox: "0 0 410 406",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M211.839 362.158C307.921 362.158 385.809 284.269 385.809 188.186C385.809 92.1043 307.921 14.2146 211.839 14.2146C115.757 14.2146 37.8665 92.1043 37.8665 188.186C37.8665 284.269 115.757 362.158 211.839 362.158Z",
    stroke: "#D1E8F7",
    strokeWidth: 1.91649,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M70.3087 92.1628C73.693 92.1628 76.4365 89.4193 76.4365 86.035C76.4365 82.6507 73.693 79.9077 70.3087 79.9077C66.9249 79.9077 64.1814 82.6507 64.1814 86.035C64.1814 89.4193 66.9249 92.1628 70.3087 92.1628Z",
    fill: "#FEBB94"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M385.808 200.94C389.194 200.94 391.94 198.197 391.94 194.812C391.94 191.428 389.194 188.685 385.808 188.685C382.428 188.685 379.682 191.428 379.682 194.812C379.682 198.197 382.428 200.94 385.808 200.94Z",
    fill: "#5661AE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M218.974 368.286C222.358 368.286 225.102 365.542 225.102 362.159C225.102 358.774 222.358 356.031 218.974 356.031C215.59 356.031 212.846 358.774 212.846 362.159C212.846 365.542 215.59 368.286 218.974 368.286Z",
    fill: "#1C85E8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M215.869 319.111C287.544 319.111 345.647 261.007 345.647 189.332C345.647 117.657 287.544 59.5538 215.869 59.5538C144.194 59.5538 86.0905 117.657 86.0905 189.332C86.0905 261.007 144.194 319.111 215.869 319.111Z",
    stroke: "#D1E8F7",
    strokeWidth: 1.42966,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M343.423 220.045C345.947 220.045 347.993 217.999 347.993 215.474C347.993 212.95 345.947 210.903 343.423 210.903C340.898 210.903 338.851 212.95 338.851 215.474C338.851 217.999 340.898 220.045 343.423 220.045Z",
    fill: "#FEBB94"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M95.5018 242.675C98.0265 242.675 100.073 240.628 100.073 238.103C100.073 235.579 98.0265 233.533 95.5018 233.533C92.9775 233.533 90.931 235.579 90.931 238.103C90.931 240.628 92.9775 242.675 95.5018 242.675Z",
    fill: "#5661AE"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M157.737 77.7502C160.262 77.7502 162.308 75.7037 162.308 73.179C162.308 70.6547 160.262 68.6082 157.737 68.6082C155.213 68.6082 153.166 70.6547 153.166 73.179C153.166 75.7037 155.213 77.7502 157.737 77.7502Z",
    fill: "#1C85E8"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M283.414 333.045H133.54C127.038 333.045 122.274 327.774 122.899 321.272L148.484 55.1207C149.108 48.6185 154.886 43.3473 161.388 43.3473H311.262C317.764 43.3473 322.529 48.6185 321.903 55.1207L296.319 321.272C295.694 327.774 289.916 333.045 283.414 333.045Z",
    fill: "#1C85E8"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M272.851 333.045H122.977C116.475 333.045 111.711 327.774 112.336 321.272L137.921 55.1207C138.546 48.6185 144.323 43.3473 150.826 43.3473H300.699C307.201 43.3473 311.965 48.6185 311.341 55.1207L285.756 321.272C285.131 327.774 279.353 333.045 272.851 333.045Z",
    fill: "url(#paint0_linear_606_22139)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M267.172 324.197H130.358C124.332 324.197 119.917 319.312 120.496 313.286L144.545 63.1057C145.125 57.0797 150.479 52.1952 156.505 52.1952H293.318C299.344 52.1952 303.76 57.0797 303.181 63.1057L279.131 313.286C278.552 319.312 273.197 324.197 267.172 324.197Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M278.143 166.007L131.377 165.876C130.778 165.893 130.182 165.78 129.629 165.548C129.076 165.316 128.579 164.968 128.172 164.528C127.764 164.089 127.455 163.567 127.265 162.998C127.075 162.429 127.008 161.826 127.07 161.23L134.982 73.3709C135.125 72.1029 135.728 70.9315 136.675 70.0773C137.623 69.2226 138.85 68.7449 140.126 68.7327L286.891 68.8632C287.491 68.8472 288.087 68.9588 288.64 69.1911C289.192 69.4239 289.689 69.7712 290.097 70.2112C290.505 70.6511 290.814 71.1726 291.004 71.7416C291.194 72.3101 291.261 72.913 291.199 73.5096L283.287 161.369C283.144 162.636 282.541 163.808 281.593 164.662C280.646 165.517 279.419 165.995 278.143 166.007Z",
    fill: "url(#paint1_linear_606_22139)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M273.522 260.675H211.49C211.032 260.685 210.578 260.595 210.158 260.413C209.738 260.232 209.362 259.962 209.055 259.623C208.748 259.283 208.518 258.882 208.38 258.446C208.241 258.009 208.198 257.549 208.253 257.095L215.785 178.74C215.894 177.768 216.352 176.869 217.074 176.211C217.796 175.552 218.733 175.178 219.71 175.159H281.743C282.2 175.15 282.654 175.239 283.074 175.421C283.494 175.602 283.87 175.872 284.177 176.212C284.484 176.551 284.715 176.952 284.853 177.388C284.991 177.825 285.034 178.286 284.979 178.74L277.447 257.095C277.338 258.066 276.88 258.965 276.158 259.623C275.436 260.282 274.499 260.656 273.522 260.675Z",
    fill: "url(#paint2_linear_606_22139)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M258.734 217.451C265.73 210.783 266.491 200.227 260.434 193.872C254.377 187.518 243.797 187.771 236.801 194.438C229.806 201.106 229.044 211.662 235.101 218.017C241.158 224.372 251.738 224.118 258.734 217.451Z",
    stroke: "#EF6A77",
    strokeWidth: 11.6898,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M239.903 221.357C234.1 218.851 230.422 212.894 231.09 205.944C231.975 196.733 240.16 189.267 249.37 189.267",
    stroke: "white",
    strokeWidth: 11.6898,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M238.526 235.693H251.288",
    stroke: "white",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M237.137 250.147H249.899",
    stroke: "white",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M231.033 242.839H257.408",
    stroke: "white",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M197.66 260.675H135.628C135.171 260.685 134.716 260.595 134.296 260.413C133.876 260.232 133.5 259.962 133.193 259.623C132.886 259.283 132.656 258.882 132.518 258.446C132.379 258.009 132.336 257.549 132.391 257.095L139.923 178.74C140.032 177.768 140.49 176.869 141.212 176.211C141.934 175.552 142.871 175.178 143.848 175.159H205.881C206.338 175.15 206.792 175.239 207.212 175.421C207.633 175.602 208.008 175.872 208.315 176.212C208.623 176.551 208.853 176.952 208.991 177.388C209.129 177.825 209.173 178.286 209.117 178.74L201.585 257.095C201.477 258.066 201.019 258.965 200.296 259.623C199.575 260.282 198.638 260.656 197.66 260.675Z",
    fill: "#FEBB94"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M182.872 217.451C189.867 210.783 190.628 200.227 184.572 193.872C178.515 187.518 167.934 187.771 160.939 194.438C153.943 201.106 153.182 211.662 159.239 218.017C165.295 224.372 175.876 224.118 182.872 217.451Z",
    stroke: "#EF6A77",
    strokeWidth: 11.6898,
    strokeMiterlimit: 10
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M188.583 205.944C187.698 215.155 179.513 222.622 170.302 222.622C161.092 222.622 154.343 215.155 155.228 205.944C156.113 196.733 164.298 189.267 173.509 189.267",
    stroke: "white",
    strokeWidth: 11.6898,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M162.665 235.693H175.427",
    stroke: "white",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M161.275 250.147H174.037",
    stroke: "white",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M155.172 242.839H181.546",
    stroke: "white",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M268.322 316.718H130.054C129.62 316.726 129.19 316.642 128.792 316.47C128.394 316.298 128.037 316.042 127.746 315.72C127.456 315.399 127.237 315.018 127.106 314.605C126.975 314.191 126.934 313.755 126.986 313.324L131.112 270.403C131.215 269.482 131.649 268.63 132.334 268.006C133.018 267.382 133.906 267.027 134.832 267.009H273.101C273.534 267 273.965 267.085 274.363 267.257C274.761 267.43 275.117 267.685 275.408 268.007C275.699 268.328 275.917 268.709 276.048 269.122C276.179 269.536 276.22 269.972 276.168 270.403L272.042 313.324C271.939 314.245 271.505 315.097 270.821 315.721C270.136 316.346 269.248 316.7 268.322 316.718Z",
    fill: "url(#paint3_linear_606_22139)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M139.682 306.766L141.633 286.475",
    stroke: "white",
    strokeWidth: 11.6898,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M153.994 292.552L152.628 306.767",
    stroke: "white",
    strokeWidth: 11.6898,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M166.473 297.406L165.573 306.766",
    stroke: "white",
    strokeWidth: 11.6898,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M180.976 281.202L178.519 306.766",
    stroke: "white",
    strokeWidth: 11.6898,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M192.363 297.406L191.464 306.766",
    stroke: "white",
    strokeWidth: 11.6898,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M206.758 282.331L204.409 306.766",
    stroke: "white",
    strokeWidth: 11.6898,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M218.33 296.621L217.354 306.766",
    stroke: "white",
    strokeWidth: 11.6898,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M230.819 301.362L230.3 306.767",
    stroke: "white",
    strokeWidth: 11.6898,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M245.195 286.475L243.245 306.766",
    stroke: "white",
    strokeWidth: 11.6898,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M258.884 278.749L256.191 306.767",
    stroke: "white",
    strokeWidth: 11.6898,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M143.265 152.534L151.036 164.706C151.387 165.256 151.506 165.921 151.368 166.558C151.23 167.196 150.847 167.752 150.3 168.108L149.044 168.923C146.942 170.289 144.415 170.846 141.934 170.489C139.452 170.132 137.184 168.887 135.552 166.983L125.24 154.958L143.265 152.534Z",
    fill: "#FFCCB3"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M137.336 157.218C137.336 157.218 140.214 167.098 145.994 170.267C147.495 169.686 148.937 168.963 150.3 168.108L143.818 157.218",
    fill: "#FCBA9F"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M4.39698 201.648L34.9195 187.021C37.7954 185.643 40.227 183.485 41.9383 180.794L71.4243 134.41C73.2597 131.523 75.9222 129.254 79.0649 127.9L121.534 109.604L112.442 178.361L112.281 180.901C112.281 180.901 101.049 209.993 73.5178 220.562L29.5009 247.484L4.39698 201.648Z",
    fill: "#FFCCB3"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6134 185.407C37.6134 185.407 52.0517 221.445 73.5176 220.562L59.8122 228.945C59.8122 228.945 13.2933 220.315 30.7066 188.968L37.6134 185.407Z",
    fill: "#FCBA9F"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M114.96 122.328C114.96 122.328 99.9446 131.427 100.741 152.533L118.773 145.795L114.96 122.328Z",
    fill: "#FCBA9F"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M152.68 152.534L160.451 164.706C160.802 165.256 160.921 165.921 160.783 166.558C160.646 167.196 160.261 167.752 159.715 168.108L158.459 168.923C156.357 170.289 153.83 170.846 151.348 170.489C148.867 170.132 146.599 168.887 144.967 166.983L134.655 154.958L152.68 152.534Z",
    fill: "#FFCCB3"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M267.559 157.334L120.793 157.203C120.193 157.219 119.597 157.108 119.045 156.875C118.492 156.643 117.995 156.295 117.587 155.855C117.179 155.415 116.87 154.894 116.68 154.325C116.49 153.756 116.424 153.154 116.485 152.557L124.398 64.6978C124.541 63.4298 125.143 62.2584 126.091 61.4042C127.038 60.55 128.265 60.0717 129.542 60.0596L276.307 60.1906C276.906 60.1741 277.502 60.2861 278.055 60.5185C278.608 60.7508 279.105 61.0986 279.512 61.5381C279.92 61.978 280.229 62.4999 280.42 63.0684C280.61 63.6374 280.676 64.2404 280.615 64.8365L272.703 152.696C272.559 153.964 271.957 155.135 271.009 155.989C270.062 156.843 268.834 157.322 267.559 157.334Z",
    fill: "#1C85E8"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M130.51 112.183C130.51 112.183 143.684 109.518 147.23 115.701C150.776 121.882 153.833 133.492 163.266 131.995C172.7 130.498 179.921 100.146 189.195 100.423C198.469 100.7 195.199 120.579 205.294 120.856C215.388 121.134 213.593 109.752 220.321 110.07C228.482 110.454 225.44 134.038 236.081 134.316C246.722 134.594 248.459 103.164 264.545 103.716",
    stroke: "white",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M138.003 74.7743L163.824 74.7971",
    stroke: "white",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M136.937 86.6109L190.299 86.6585",
    stroke: "white",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M86.975 156.898L105.802 148.605L125.056 135.462C130.119 132.006 140.694 130.449 144.5 135.254C148.373 140.142 144.023 149.81 139.327 153.911L121.533 169.449L112.281 180.901L86.975 156.898Z",
    fill: "#FFCCB3"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M125.24 140.453C125.24 140.453 127.782 150.255 134.372 151.95L141.362 146.045C142.07 145.517 142.664 144.851 143.107 144.086C143.55 143.322 143.832 142.475 143.937 141.598C144.042 140.72 143.967 139.831 143.717 138.983C143.466 138.136 143.046 137.348 142.482 136.668C141.496 135.481 140.12 134.683 138.6 134.416C137.08 134.149 135.514 134.432 134.183 135.213L125.24 140.453Z",
    stroke: "#FF967C",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M36.0789 185.809C36.0789 185.809 32.4302 211.903 64.1814 226.844C64.1814 226.844 41.3728 247.767 32.5791 251.285C23.7859 254.802 -9.25306 218.851 2.49804 198.445C5.79355 192.723 36.0789 185.809 36.0789 185.809Z",
    fill: "#1C85E8"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M156.384 158.336C156.384 158.336 144.009 158.589 139.701 160.843L136.592 157.217L155.67 157.218L156.384 158.336Z",
    fill: "#FCBA9F"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M384.246 157.334H296.254C289.625 157.334 284.728 151.96 285.315 145.332L297.121 12.0014C297.707 5.37351 303.556 0 310.185 0H398.177C404.808 0 409.702 5.37351 409.115 12.0014L397.309 145.332C396.722 151.96 390.872 157.334 384.246 157.334Z",
    fill: "#FEBB94"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M371.65 75.2864C385.586 61.9565 386.987 40.8121 374.788 28.0594C362.587 15.3066 341.402 15.7742 327.468 29.1042C313.535 42.4342 312.131 63.5785 324.331 76.3313C336.532 89.0845 357.718 88.6164 371.65 75.2864Z",
    fill: "white"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M351.424 53.2329L373.512 73.3785C373.512 73.3785 378.538 67.9774 380.036 64.1172L351.424 53.2329Z",
    fill: "url(#paint4_linear_606_22139)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M352.895 14.5342L349.756 49.981C349.686 50.6266 349.807 51.2786 350.103 51.8568C350.4 52.4345 350.859 52.9127 351.424 53.2329L381.394 69.918C381.394 69.918 399.191 20.2676 352.895 14.5342Z",
    fill: "#1C85E8"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M305.984 110.143H342.437",
    stroke: "white",
    strokeWidth: 8,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M303.316 140.281H339.769",
    stroke: "white",
    strokeWidth: 8,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M304.665 125.041H379.997",
    stroke: "white",
    strokeWidth: 8,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M276.032 255.557C276.032 255.557 287.783 252.423 294.036 259.158C294.036 259.158 305.277 257.116 309.848 263.37C309.848 263.37 319.813 263.947 322.699 268.012C325.099 268.343 327.369 269.304 329.277 270.798C331.184 272.291 332.663 274.263 333.561 276.513C336.286 282.936 333.974 320.068 331.266 333.373C330.589 336.701 330.821 340.15 331.938 343.357L338.828 363.157L291.157 383.085L279.84 353.566C279.84 353.566 266.063 331.427 264.095 327.491C262.127 323.555 265.463 290.895 258.744 270.492L276.032 255.557Z",
    fill: "#FFCCB3"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M285.988 369.603L284.613 366.016C284.613 366.016 309.349 364.434 331.938 343.357L334.098 349.566C334.098 349.566 331.308 362.391 318.605 368.435C305.902 374.48 285.988 369.603 285.988 369.603Z",
    fill: "#FCBA9F"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M285.988 369.603C285.988 369.603 315.929 372.33 334.098 349.566C334.098 349.566 340.806 353.083 351.106 378.83C354.27 386.739 301.442 414.895 292.901 403.191C292.901 403.191 285.527 387.593 285.988 369.603Z",
    fill: "#5661AE"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M261.674 282.808C261.674 282.808 260.641 288.287 255.758 288.288C252.572 288.288 238.763 284.116 229.546 281.215C227.038 280.426 224.348 280.426 221.84 281.215C219.332 282.004 217.127 283.545 215.524 285.628L214.963 286.355C214.685 286.716 214.483 287.129 214.369 287.57C214.255 288.011 214.232 288.47 214.301 288.921C214.37 289.371 214.53 289.802 214.77 290.189C215.011 290.576 215.328 290.91 215.701 291.17C223.504 296.618 244.576 311.404 247.271 314.099C250.588 317.415 269.056 336.008 269.056 336.008L261.674 282.808Z",
    fill: "#FFCCB3"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M260.553 277.318C260.553 277.318 270.534 290.828 269.057 293.786C267.579 296.743 252.102 287.701 252.102 287.701C252.102 287.701 264.591 290.914 260.553 277.318Z",
    fill: "#FCBA9F"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M258.744 270.492L241.949 219.488C241.373 217.739 241.154 215.891 241.305 214.055C241.457 212.22 241.975 210.433 242.83 208.801C243.685 207.17 244.858 205.726 246.281 204.557C247.704 203.387 249.348 202.515 251.114 201.993C252.56 201.565 254.112 201.681 255.478 202.318C256.844 202.955 257.93 204.07 258.531 205.453L282.093 259.614L258.744 270.492Z",
    fill: "#FFCCB3"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M251.461 248.373C251.937 249.155 252.569 249.83 253.318 250.356C254.068 250.883 254.917 251.248 255.814 251.43",
    stroke: "#FF967C",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M257.504 222.263C259.547 221.358 261.801 220.092 262.771 218.615L256.517 203.766C256.383 203.446 256.183 203.158 255.929 202.922C255.675 202.685 255.375 202.505 255.046 202.393C254.718 202.282 254.37 202.242 254.024 202.275C253.679 202.309 253.345 202.415 253.044 202.587C250.819 203.871 247.881 206.189 247.767 209.517L251.997 220.042C252.204 220.557 252.513 221.023 252.905 221.415C253.297 221.807 253.764 222.116 254.278 222.323C254.792 222.531 255.343 222.632 255.897 222.622C256.451 222.612 256.998 222.489 257.504 222.263Z",
    stroke: "#FF967C",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M280.198 255.257L285.988 268.012",
    stroke: "#FF967C",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M294.268 259.419C297.21 263.637 298.787 268.657 298.786 273.8",
    stroke: "#FF967C",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M310.124 263.608C310.124 263.608 313.039 270.293 313.279 275.579",
    stroke: "#FF967C",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M323.107 268.409C324.255 271.229 324.7 274.287 324.404 277.318",
    stroke: "#FF967C",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M228.034 297.407C228.034 297.407 231.483 293.026 230.3 290.83C229.117 288.633 223.854 285.526 220.813 285.864C219.362 286.083 217.961 286.56 216.679 287.273C216.445 287.394 216.248 287.575 216.107 287.797C215.965 288.019 215.884 288.274 215.871 288.537C215.858 288.8 215.914 289.062 216.033 289.296C216.153 289.531 216.331 289.73 216.552 289.874L228.034 297.407Z",
    stroke: "#FF967C",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M168.725 350.813H63.6535C63.2199 350.822 62.7896 350.737 62.3914 350.565C61.9932 350.393 61.6366 350.137 61.3461 349.815C61.0551 349.494 60.8368 349.113 60.7058 348.7C60.5744 348.287 60.5336 347.85 60.586 347.419L64.7119 304.498C64.8148 303.577 65.2489 302.725 65.9333 302.101C66.6177 301.477 67.5054 301.123 68.4319 301.104H173.504C173.938 301.095 174.368 301.18 174.766 301.352C175.164 301.524 175.52 301.78 175.811 302.101C176.102 302.424 176.32 302.804 176.452 303.217C176.583 303.631 176.623 304.067 176.572 304.498L172.446 347.419C172.342 348.34 171.908 349.192 171.224 349.816C170.54 350.44 169.652 350.795 168.725 350.813Z",
    fill: "#FEBB94"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M73.5178 312.297H138.362",
    stroke: "#EF6A77",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M73.5178 312.297H118.579",
    stroke: "white",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M72.5475 325.959H137.392",
    stroke: "#EF6A77",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M72.5475 325.959H99.4878",
    stroke: "white",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M70.4275 339.62H135.272",
    stroke: "#EF6A77",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M70.4275 339.62H86.9026",
    stroke: "white",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M161.316 316.171C163.456 316.171 165.191 314.437 165.191 312.297C165.191 310.157 163.456 308.422 161.316 308.422C159.176 308.422 157.442 310.157 157.442 312.297C157.442 314.437 159.176 316.171 161.316 316.171Z",
    fill: "white"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M160.059 329.235C162.2 329.235 163.934 327.501 163.934 325.361C163.934 323.221 162.2 321.486 160.059 321.486C157.919 321.486 156.185 323.221 156.185 325.361C156.185 327.501 157.919 329.235 160.059 329.235Z",
    fill: "white"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M158.657 343.495C160.797 343.495 162.532 341.76 162.532 339.62C162.532 337.48 160.797 335.745 158.657 335.745C156.517 335.745 154.782 337.48 154.782 339.62C154.782 341.76 156.517 343.495 158.657 343.495Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_606_22139",
    x1: 188.787,
    y1: -48.8277,
    x2: 326.466,
    y2: 641.116,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94B9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_606_22139",
    x1: 205.047,
    y1: 68.5014,
    x2: 218.397,
    y2: 276.31,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94B9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_606_22139",
    x1: 244.705,
    y1: 174.955,
    x2: 266.541,
    y2: 355.765,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94B9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_606_22139",
    x1: 197.862,
    y1: 266.89,
    x2: 201.708,
    y2: 373.386,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94B9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_606_22139",
    x1: 365.017,
    y1: 53.1849,
    x2: 368.298,
    y2: 96.1497,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94B9FF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnboardingSecond);
export default __webpack_public_path__ + "static/media/onboarding-second.7f8552d0cae20b1f17f88b86da3af65e.svg";
export { ForwardRef as ReactComponent };